import { FC, SVGProps } from 'react'
import ActivityBarsIcon from '@assets/images/icons/activity-bars.svg?react'
import ActivityBoxIcon from '@assets/images/icons/activity-box.svg?react'
import ActivityIcon from '@assets/images/icons/activity.svg?react'
import AlertCircleIcon from '@assets/images/icons/alert-circle.svg?react'
import AlertTriangleIcon from '@assets/images/icons/alert-triangle.svg?react'
import AppsIcon from '@assets/images/icons/apps.svg?react'
import ArchiveFadedIcon from '@assets/images/icons/archive-faded.svg?react'
import ArchiveIcon from '@assets/images/icons/archive.svg?react'
import ArrowDownIcon from '@assets/images/icons/arrow-down.svg?react'
import ArrowLeftIcon from '@assets/images/icons/arrow-left.svg?react'
import ArrowRightIcon from '@assets/images/icons/arrow-right.svg?react'
import AttachIcon from '@assets/images/icons/attach.svg?react'
import AuditLogIcon from '@assets/images/icons/audit-log.svg?react'
import BankAccountsIcon from '@assets/images/icons/bank-accounts.svg?react'
import BankIcon from '@assets/images/icons/bank.svg?react'
import BanknoteIcon from '@assets/images/icons/banknote.svg?react'
import BellOffIcon from '@assets/images/icons/bell-off.svg?react'
import BellIcon from '@assets/images/icons/bell.svg?react'
import BookOpenIcon from '@assets/images/icons/book-open.svg?react'
import BrainIcon from '@assets/images/icons/brain.svg?react'
import BriefcaseIcon from '@assets/images/icons/briefcase.svg?react'
import CalendarCheckIcon from '@assets/images/icons/calendar-check.svg?react'
import CalendarRangeIcon from '@assets/images/icons/calendar-range.svg?react'
import CalendarXIcon from '@assets/images/icons/calendar-x.svg?react'
import CalendarIcon from '@assets/images/icons/calendar.svg?react'
import ChartBarsIcon from '@assets/images/icons/chart-bars.svg?react'
import ChartIcon from '@assets/images/icons/chart.svg?react'
import ChatNotificationIcon from '@assets/images/icons/chat-notification.svg?react'
import CheckBadgeIcon from '@assets/images/icons/check-badge.svg?react'
import CheckCirclePlusIcon from '@assets/images/icons/check-circle-plus.svg?react'
import CheckCircleIcon from '@assets/images/icons/check-circle.svg?react'
import CheckShieldIcon from '@assets/images/icons/check-shield.svg?react'
import CheckIcon from '@assets/images/icons/check.svg?react'
import CheckboxCheckedDisabledIcon from '@assets/images/icons/checkbox-checked-disabled.svg?react'
import CheckboxCheckedIcon from '@assets/images/icons/checkbox-checked.svg?react'
import CheckboxUncheckedDisabledIcon from '@assets/images/icons/checkbox-unchecked-disabled.svg?react'
import CheckboxUncheckedIcon from '@assets/images/icons/checkbox-unchecked.svg?react'
import ChevronDownIcon from '@assets/images/icons/chevron-down.svg?react'
import ChevronLeftIcon from '@assets/images/icons/chevron-left.svg?react'
import ChevronRightIcon from '@assets/images/icons/chevron-right.svg?react'
import ChevronUpIcon from '@assets/images/icons/chevron-up.svg?react'
import CircleSlashIcon from '@assets/images/icons/circle-slash.svg?react'
import CircleXIcon from '@assets/images/icons/circle-x.svg?react'
import ClipboardClockIcon from '@assets/images/icons/clipboard-clock.svg?react'
import ClockIcon from '@assets/images/icons/clock.svg?react'
import CloudDownloadIcon from '@assets/images/icons/cloud-download.svg?react'
import CodeIcon from '@assets/images/icons/code.svg?react'
import CollectionsIcon from '@assets/images/icons/collections.svg?react'
import CommentsIcon from '@assets/images/icons/comments.svg?react'
import CompanyInfoStepIcon from '@assets/images/icons/company-info-step.svg?react'
import CompanyInfoIcon from '@assets/images/icons/company-info.svg?react'
import ContrastIcon from '@assets/images/icons/contrast.svg?react'
import CopyIcon from '@assets/images/icons/copy.svg?react'
import CpuIcon from '@assets/images/icons/cpu.svg?react'
import DashboardIcon from '@assets/images/icons/dashboard.svg?react'
import DataSourceIcon from '@assets/images/icons/data-source.svg?react'
import DdStepActiveIcon from '@assets/images/icons/dd-step-active.svg?react'
import DdStepCompletedIcon from '@assets/images/icons/dd-step-completed.svg?react'
import DepositIcon from '@assets/images/icons/deposit.svg?react'
import DocumentIcon from '@assets/images/icons/document.svg?react'
import DocumentsIcon from '@assets/images/icons/documents.svg?react'
import DollarCircleIcon from '@assets/images/icons/dollar-circle.svg?react'
import DollarSerifIcon from '@assets/images/icons/dollar-serif.svg?react'
import DollarSignIcon from '@assets/images/icons/dollar-sign.svg?react'
import DownloadIcon from '@assets/images/icons/download.svg?react'
import DragIcon from '@assets/images/icons/drag.svg?react'
import EditIcon from '@assets/images/icons/edit.svg?react'
import EmojiPlusIcon from '@assets/images/icons/emoji-plus.svg?react'
import EmojiIcon from '@assets/images/icons/emoji.svg?react'
import EnterIcon from '@assets/images/icons/enter.svg?react'
import ExpandIcon from '@assets/images/icons/expand.svg?react'
import ExternalLinkIcon from '@assets/images/icons/external-link.svg?react'
import EyeOffIcon from '@assets/images/icons/eye-off.svg?react'
import EyeIcon from '@assets/images/icons/eye.svg?react'
import FilePenIcon from '@assets/images/icons/file-pen.svg?react'
import FileTextIcon from '@assets/images/icons/file-text.svg?react'
import FilterLinesIcon from '@assets/images/icons/filter-lines.svg?react'
import FilterIcon from '@assets/images/icons/filter.svg?react'
import FinancialDataIntegrationStepIcon from '@assets/images/icons/financial-data-integration-step.svg?react'
import FlagFlatIcon from '@assets/images/icons/flag-flat.svg?react'
import FoldHorizontalIcon from '@assets/images/icons/fold-horizontal.svg?react'
import FolderIcon from '@assets/images/icons/folder.svg?react'
import FundingTrackerIcon from '@assets/images/icons/funding-tracker.svg?react'
import GavelIcon from '@assets/images/icons/gavel.svg?react'
import GifIcon from '@assets/images/icons/gif.svg?react'
import GlobeIcon from '@assets/images/icons/globe.svg?react'
import GridMapIcon from '@assets/images/icons/grid-map.svg?react'
import HashIcon from '@assets/images/icons/hash.svg?react'
import HeadphonesIcon from '@assets/images/icons/headphones.svg?react'
import HelpCircleIcon from '@assets/images/icons/help-circle.svg?react'
import HighlighterIcon from '@assets/images/icons/highlighter.svg?react'
import HomeIcon from '@assets/images/icons/home.svg?react'
import IndentIncreaseIcon from '@assets/images/icons/indent-increase.svg?react'
import InfoIcon from '@assets/images/icons/info.svg?react'
import InventoryIcon from '@assets/images/icons/inventory.svg?react'
import LightbulbIcon from '@assets/images/icons/lightbulb.svg?react'
import LinkIcon from '@assets/images/icons/link.svg?react'
import ListPlusIcon from '@assets/images/icons/list-plus.svg?react'
import ListThumbnailsIcon from '@assets/images/icons/list-thumbnails.svg?react'
import ListIcon from '@assets/images/icons/list.svg?react'
import LoaderIcon from '@assets/images/icons/loader.svg?react'
import LockOpenIcon from '@assets/images/icons/lock-open.svg?react'
import LockIcon from '@assets/images/icons/lock.svg?react'
import LogoutAltIcon from '@assets/images/icons/logout-alt.svg?react'
import LogoutIcon from '@assets/images/icons/logout.svg?react'
import MailPersonalInfoIcon from '@assets/images/icons/mail-personal-info.svg?react'
import MailIcon from '@assets/images/icons/mail.svg?react'
import MessagePlusIcon from '@assets/images/icons/message-plus.svg?react'
import MessageQuoteIcon from '@assets/images/icons/message-quote.svg?react'
import MessageReadIcon from '@assets/images/icons/message-read.svg?react'
import MessageTextIcon from '@assets/images/icons/message-text.svg?react'
import MessageUnreadIcon from '@assets/images/icons/message-unread.svg?react'
import MessageIcon from '@assets/images/icons/message.svg?react'
import MessagesIcon from '@assets/images/icons/messages.svg?react'
import MicOffIcon from '@assets/images/icons/mic-off.svg?react'
import MicIcon from '@assets/images/icons/mic.svg?react'
import MoonIcon from '@assets/images/icons/moon.svg?react'
import MoreCircleIcon from '@assets/images/icons/more-circle.svg?react'
import MoreHorizontalIcon from '@assets/images/icons/more-horizontal.svg?react'
import MoreVerticalIcon from '@assets/images/icons/more-vertical.svg?react'
import NoteAddIcon from '@assets/images/icons/note-add.svg?react'
import NoteSmallAltIcon from '@assets/images/icons/note-small-alt.svg?react'
import NoteSmallIcon from '@assets/images/icons/note-small.svg?react'
import NoteIcon from '@assets/images/icons/note.svg?react'
import PanelOpenIcon from '@assets/images/icons/panel-open.svg?react'
import PartnersAndToolsIcon from '@assets/images/icons/partners-and-tools.svg?react'
import PauseCircleIcon from '@assets/images/icons/pause-circle.svg?react'
import PdfIcon from '@assets/images/icons/pdf.svg?react'
import PeopleActiveIcon from '@assets/images/icons/people-active.svg?react'
import PeopleIcon from '@assets/images/icons/people.svg?react'
import PercentIcon from '@assets/images/icons/percent.svg?react'
import PhoneCallIcon from '@assets/images/icons/phone-call.svg?react'
import PhoneIcon from '@assets/images/icons/phone.svg?react'
import PieChartActiveIcon from '@assets/images/icons/pie-chart-active.svg?react'
import PieChartIcon from '@assets/images/icons/pie-chart.svg?react'
import PinFilledIcon from '@assets/images/icons/pin-filled.svg?react'
import PinIcon from '@assets/images/icons/pin.svg?react'
import PlayIcon from '@assets/images/icons/play.svg?react'
import PlugIcon from '@assets/images/icons/plug.svg?react'
import PlusIcon from '@assets/images/icons/plus.svg?react'
import PriorityIcon from '@assets/images/icons/priority.svg?react'
import ProspectsIcon from '@assets/images/icons/prospects.svg?react'
import RadioCheckedIcon from '@assets/images/icons/radio-checked.svg?react'
import RadioUncheckedIcon from '@assets/images/icons/radio-unchecked.svg?react'
import ReceiptIcon from '@assets/images/icons/receipt.svg?react'
import ReferencesIcon from '@assets/images/icons/references.svg?react'
import RefreshIcon from '@assets/images/icons/refresh.svg?react'
import RepeatIcon from '@assets/images/icons/repeat.svg?react'
import ReplayIcon from '@assets/images/icons/replay.svg?react'
import ReplyIcon from '@assets/images/icons/reply.svg?react'
import ReportingIcon from '@assets/images/icons/reporting.svg?react'
import ScanIcon from '@assets/images/icons/scan.svg?react'
import SearchIcon from '@assets/images/icons/search.svg?react'
import SendIcon from '@assets/images/icons/send.svg?react'
import SettingsIcon from '@assets/images/icons/settings.svg?react'
import ShrinkIcon from '@assets/images/icons/shrink.svg?react'
import SidebarPinIcon from '@assets/images/icons/sidebar-pin.svg?react'
import SidemenuActivityIcon from '@assets/images/icons/sidemenu-activity.svg?react'
import SidemenuAnalyticsIcon from '@assets/images/icons/sidemenu-analytics.svg?react'
import SidemenuFundingIcon from '@assets/images/icons/sidemenu-funding.svg?react'
import SidemenuOverviewIcon from '@assets/images/icons/sidemenu-overview.svg?react'
import SidemenuReportingIcon from '@assets/images/icons/sidemenu-reporting.svg?react'
import SlidersIcon from '@assets/images/icons/sliders.svg?react'
import SortCaretIcon from '@assets/images/icons/sort-caret.svg?react'
import SortIcon from '@assets/images/icons/sort.svg?react'
import SparklesIcon from '@assets/images/icons/sparkles.svg?react'
import StarIcon from '@assets/images/icons/star.svg?react'
import StopIcon from '@assets/images/icons/stop.svg?react'
import StrikethroughIcon from '@assets/images/icons/strikethrough.svg?react'
import SubtaskIcon from '@assets/images/icons/subtask.svg?react'
import SunIcon from '@assets/images/icons/sun.svg?react'
import TableIcon from '@assets/images/icons/table.svg?react'
import TextIcon from '@assets/images/icons/text.svg?react'
import ThumbsDownIcon from '@assets/images/icons/thumbs-down.svg?react'
import ThumbsUpIcon from '@assets/images/icons/thumbs-up.svg?react'
import TransferIcon from '@assets/images/icons/transfer.svg?react'
import TrashIcon from '@assets/images/icons/trash.svg?react'
import UnderReviewTrackerIcon from '@assets/images/icons/under-review-tracker.svg?react'
import UnderwritingIcon from '@assets/images/icons/underwriting.svg?react'
import UndoIcon from '@assets/images/icons/undo.svg?react'
import UnfoldHorizontalIcon from '@assets/images/icons/unfold-horizontal.svg?react'
import UnplugIcon from '@assets/images/icons/unplug.svg?react'
import UploadDocumentsStepIcon from '@assets/images/icons/upload-documents-step.svg?react'
import UploadFileFundingIcon from '@assets/images/icons/upload-file-funding.svg?react'
import UploadIcon from '@assets/images/icons/upload.svg?react'
import UserManagementActiveIcon from '@assets/images/icons/user-management-active.svg?react'
import UserManagementIcon from '@assets/images/icons/user-management.svg?react'
import UserMinusIcon from '@assets/images/icons/user-minus.svg?react'
import UserPlusIcon from '@assets/images/icons/user-plus.svg?react'
import UserIcon from '@assets/images/icons/user.svg?react'
import VideoIcon from '@assets/images/icons/video.svg?react'
import WandIcon from '@assets/images/icons/wand.svg?react'
import WindowOpenIcon from '@assets/images/icons/window-open.svg?react'
import XCircleIcon from '@assets/images/icons/x-circle.svg?react'
import XIcon from '@assets/images/icons/x.svg?react'
import ZapIcon from '@assets/images/icons/zap.svg?react'
import cn from 'classnames'
import styles from './Icon.module.scss'

/**
 * The canonical Atlas icon set, all on a 24x24 viewBox. Icons drawn for the set share a
 * 1.75 stroke, which keeps their optical weight consistent at 16px; the ones moved in from
 * one-off files keep their original drawing, weight and fill, fitted into the 24 box.
 * New pictures belong here rather than as one-off SVGs in assets/images.
 */
const ICONS = {
  activity: ActivityIcon,
  'activity-bars': ActivityBarsIcon,
  'activity-box': ActivityBoxIcon,
  'alert-circle': AlertCircleIcon,
  'alert-triangle': AlertTriangleIcon,
  apps: AppsIcon,
  archive: ArchiveIcon,
  'archive-faded': ArchiveFadedIcon,
  'arrow-down': ArrowDownIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  attach: AttachIcon,
  'audit-log': AuditLogIcon,
  bank: BankIcon,
  'bank-accounts': BankAccountsIcon,
  banknote: BanknoteIcon,
  bell: BellIcon,
  'bell-off': BellOffIcon,
  'book-open': BookOpenIcon,
  brain: BrainIcon,
  briefcase: BriefcaseIcon,
  calendar: CalendarIcon,
  'calendar-check': CalendarCheckIcon,
  'calendar-range': CalendarRangeIcon,
  'calendar-x': CalendarXIcon,
  chart: ChartIcon,
  'chart-bars': ChartBarsIcon,
  'chat-notification': ChatNotificationIcon,
  check: CheckIcon,
  'check-badge': CheckBadgeIcon,
  'check-circle': CheckCircleIcon,
  'check-circle-plus': CheckCirclePlusIcon,
  'check-shield': CheckShieldIcon,
  'checkbox-checked': CheckboxCheckedIcon,
  'checkbox-checked-disabled': CheckboxCheckedDisabledIcon,
  'checkbox-unchecked': CheckboxUncheckedIcon,
  'checkbox-unchecked-disabled': CheckboxUncheckedDisabledIcon,
  'chevron-down': ChevronDownIcon,
  'chevron-left': ChevronLeftIcon,
  'chevron-right': ChevronRightIcon,
  'chevron-up': ChevronUpIcon,
  'circle-slash': CircleSlashIcon,
  'circle-x': CircleXIcon,
  'clipboard-clock': ClipboardClockIcon,
  clock: ClockIcon,
  'cloud-download': CloudDownloadIcon,
  code: CodeIcon,
  collections: CollectionsIcon,
  comments: CommentsIcon,
  'company-info': CompanyInfoIcon,
  'company-info-step': CompanyInfoStepIcon,
  contrast: ContrastIcon,
  copy: CopyIcon,
  cpu: CpuIcon,
  dashboard: DashboardIcon,
  'data-source': DataSourceIcon,
  'dd-step-active': DdStepActiveIcon,
  'dd-step-completed': DdStepCompletedIcon,
  deposit: DepositIcon,
  document: DocumentIcon,
  documents: DocumentsIcon,
  'dollar-circle': DollarCircleIcon,
  'dollar-serif': DollarSerifIcon,
  'dollar-sign': DollarSignIcon,
  download: DownloadIcon,
  drag: DragIcon,
  edit: EditIcon,
  emoji: EmojiIcon,
  'emoji-plus': EmojiPlusIcon,
  enter: EnterIcon,
  expand: ExpandIcon,
  'external-link': ExternalLinkIcon,
  eye: EyeIcon,
  'eye-off': EyeOffIcon,
  'file-pen': FilePenIcon,
  'file-text': FileTextIcon,
  filter: FilterIcon,
  'filter-lines': FilterLinesIcon,
  'financial-data-integration-step': FinancialDataIntegrationStepIcon,
  'flag-flat': FlagFlatIcon,
  'fold-horizontal': FoldHorizontalIcon,
  folder: FolderIcon,
  'funding-tracker': FundingTrackerIcon,
  gavel: GavelIcon,
  gif: GifIcon,
  globe: GlobeIcon,
  'grid-map': GridMapIcon,
  hash: HashIcon,
  headphones: HeadphonesIcon,
  'help-circle': HelpCircleIcon,
  highlighter: HighlighterIcon,
  home: HomeIcon,
  'indent-increase': IndentIncreaseIcon,
  info: InfoIcon,
  inventory: InventoryIcon,
  lightbulb: LightbulbIcon,
  link: LinkIcon,
  list: ListIcon,
  'list-plus': ListPlusIcon,
  'list-thumbnails': ListThumbnailsIcon,
  loader: LoaderIcon,
  lock: LockIcon,
  'lock-open': LockOpenIcon,
  logout: LogoutIcon,
  'logout-alt': LogoutAltIcon,
  mail: MailIcon,
  'mail-personal-info': MailPersonalInfoIcon,
  message: MessageIcon,
  'message-plus': MessagePlusIcon,
  'message-quote': MessageQuoteIcon,
  'message-read': MessageReadIcon,
  'message-text': MessageTextIcon,
  'message-unread': MessageUnreadIcon,
  messages: MessagesIcon,
  mic: MicIcon,
  'mic-off': MicOffIcon,
  moon: MoonIcon,
  'more-circle': MoreCircleIcon,
  'more-horizontal': MoreHorizontalIcon,
  'more-vertical': MoreVerticalIcon,
  note: NoteIcon,
  'note-add': NoteAddIcon,
  'note-small': NoteSmallIcon,
  'note-small-alt': NoteSmallAltIcon,
  'panel-open': PanelOpenIcon,
  'partners-and-tools': PartnersAndToolsIcon,
  'pause-circle': PauseCircleIcon,
  pdf: PdfIcon,
  people: PeopleIcon,
  'people-active': PeopleActiveIcon,
  percent: PercentIcon,
  phone: PhoneIcon,
  'phone-call': PhoneCallIcon,
  'pie-chart': PieChartIcon,
  'pie-chart-active': PieChartActiveIcon,
  pin: PinIcon,
  // The pin's state is carried by fill, so the pair has to be the same drawing twice.
  'pin-filled': PinFilledIcon,
  play: PlayIcon,
  plug: PlugIcon,
  plus: PlusIcon,
  priority: PriorityIcon,
  prospects: ProspectsIcon,
  'radio-checked': RadioCheckedIcon,
  'radio-unchecked': RadioUncheckedIcon,
  receipt: ReceiptIcon,
  references: ReferencesIcon,
  refresh: RefreshIcon,
  repeat: RepeatIcon,
  replay: ReplayIcon,
  reply: ReplyIcon,
  reporting: ReportingIcon,
  scan: ScanIcon,
  search: SearchIcon,
  send: SendIcon,
  settings: SettingsIcon,
  shrink: ShrinkIcon,
  'sidebar-pin': SidebarPinIcon,
  'sidemenu-activity': SidemenuActivityIcon,
  'sidemenu-analytics': SidemenuAnalyticsIcon,
  'sidemenu-funding': SidemenuFundingIcon,
  'sidemenu-overview': SidemenuOverviewIcon,
  'sidemenu-reporting': SidemenuReportingIcon,
  sliders: SlidersIcon,
  sort: SortIcon,
  'sort-caret': SortCaretIcon,
  sparkles: SparklesIcon,
  star: StarIcon,
  stop: StopIcon,
  strikethrough: StrikethroughIcon,
  subtask: SubtaskIcon,
  sun: SunIcon,
  table: TableIcon,
  text: TextIcon,
  'thumbs-down': ThumbsDownIcon,
  'thumbs-up': ThumbsUpIcon,
  transfer: TransferIcon,
  trash: TrashIcon,
  'under-review-tracker': UnderReviewTrackerIcon,
  underwriting: UnderwritingIcon,
  undo: UndoIcon,
  'unfold-horizontal': UnfoldHorizontalIcon,
  unplug: UnplugIcon,
  upload: UploadIcon,
  'upload-documents-step': UploadDocumentsStepIcon,
  'upload-file-funding': UploadFileFundingIcon,
  user: UserIcon,
  'user-management': UserManagementIcon,
  'user-management-active': UserManagementActiveIcon,
  'user-minus': UserMinusIcon,
  'user-plus': UserPlusIcon,
  video: VideoIcon,
  wand: WandIcon,
  'window-open': WindowOpenIcon,
  x: XIcon,
  'x-circle': XCircleIcon,
  zap: ZapIcon,
} satisfies Record<string, FC<SVGProps<SVGSVGElement>>>

export type IconName = keyof typeof ICONS

/**
 * Every name in the set. Derived from `ICONS` rather than written out a second time, so a
 * hand-added icon is picked up by the tests that assert the shared wrapper instead of
 * silently skipping the check.
 */
export const ICON_NAMES = Object.keys(ICONS) as IconName[]

/** Narrows a stored string (e.g. a `client_banners.icon` value) to a canonical icon name. */
export const isIconName = (value: string): value is IconName => Object.hasOwn(ICONS, value)

export type IconSize = 'xs' | 'sm' | 'md' | 'lg'

/** One class per size; each resolves to the matching `--icon-*` token in tokens.scss. */
const SIZE_CLASS: Record<IconSize, string> = {
  xs: styles.xs,
  sm: styles.sm,
  md: styles.md,
  lg: styles.lg,
}

// width/height/fill/stroke/color are deliberately not settable: the size comes from one of
// the four tokens and the color from `currentColor`. Anything else defeats the point of the set.
type SvgPassThroughProps = Omit<
  SVGProps<SVGSVGElement>,
  'name' | 'width' | 'height' | 'fill' | 'stroke' | 'color'
>

interface IProps extends SvgPassThroughProps {
  name: IconName
  size?: IconSize
}

/**
 * Renders one of the canonical icons at one of the four fixed sizes. Color is never set
 * here — the SVG strokes with `currentColor`, so the icon takes the text color of whatever
 * control it sits in and needs no separate dark-mode version.
 *
 * Decorative by default, so it is hidden from AT; a caller that needs it announced passes
 * `aria-hidden={false}` with an `aria-label`. `data-icon` lets a container that still sizes
 * one-off SVGs exclude it with `svg:not([data-icon])`.
 */
const Icon = ({ name, size = 'sm', className, ...rest }: IProps) => {
  const Svg = ICONS[name]

  return (
    <Svg
      aria-hidden
      data-icon={name}
      {...rest}
      className={cn(styles.icon, SIZE_CLASS[size], className)}
    />
  )
}

/** A canonical name, or a one-off SVG for a picture the set doesn't have yet. */
export type IconOrSvg = IconName | FC<SVGProps<SVGSVGElement>>

/** Renders an `IconOrSvg`; `svgClassName` only reaches a one-off SVG, which sizes itself. */
export const IconOrSvgGlyph = ({
  icon,
  size,
  svgClassName,
}: {
  icon: IconOrSvg
  size: IconSize
  svgClassName?: string
}) => {
  if (typeof icon === 'string') {
    return <Icon name={icon} size={size} />
  }

  const Svg = icon

  return <Svg className={svgClassName} />
}

export default Icon
